module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_info-fed0e046837cf6c60df6494f31ab94dd.png";